import { FC, PropsWithChildren } from 'react';

import { CatUtilityNav } from '@blocks-react/components/UtilityNav';
import { HeaderNavSectionProps } from './types';
import cx from 'classnames';

import styles from './HeaderNavSection.module.scss';

export const HeaderNavSection: FC<PropsWithChildren<HeaderNavSectionProps>> = ({
  fullWidth,
  classname,
  children,
}) => (
  <CatUtilityNav
    data-testid="cat-nav-section-search-bar"
    className={cx(
      {
        [styles['header__nav-section--full-width']]: fullWidth,
      },
      classname ?? ''
    )}
  >
    {children}
  </CatUtilityNav>
);
